/*
* Utility functions used throughout Model1 Template
*/
var M1 = M1 || {};

M1.util = {};

/*
 * Vertically and horizontally centers absolutely positioned object onscreen
 * 
 * @param element - jQuery dom element
 */
M1.util.centerElement = function(element){
	var $ = jQuery;
	var elementMaxWidth = parseInt(element.css('max-width').replace(/px$/,''));
	if(isNaN(elementMaxWidth)){
		elementMaxWidth = 0;
	}
	var elementWidth = element.width();
	var windowWidth = window.innerWidth;
	//set element flush against left side of screen on small devices
	var leftOffset;
	if(elementMaxWidth < windowWidth){
		leftOffset = Math.floor((windowWidth - elementWidth) / 2 * 0.70);
	}
	else{
		leftOffset = 0;
	}
	var topOffset = $(document).scrollTop() + 70;

	element.css({
		'left': leftOffset,
		'top': topOffset
	});
};